import type * as Types from '../../../schemas/shopify/admin.types';

import { PickPagePageNodeFragmentDoc } from '../fragments/pickPagePage.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcherGemX } from '../../utils/gatewayClientGemX';
export type PickPagePagesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortKey?: Types.InputMaybe<Types.PageSortKeys>;
  reverse?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type PickPagePagesQueryResponse = {
  pages: {
    edges: Array<
      Pick<Types.PageEdge, 'cursor'> & {
        node: Pick<Types.Page, 'id' | 'handle' | 'title' | 'isPublished' | 'templateSuffix'>;
      }
    >;
    pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>;
  };
};

export const PickPagePagesDocument = `
    query PickPagePages($first: Int!, $after: String, $query: String, $sortKey: PageSortKeys, $reverse: Boolean) {
  pages(
    first: $first
    after: $after
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    edges {
      cursor
      node {
        ...PickPagePageNode
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PickPagePageNodeFragmentDoc}`;

export const usePickPagePagesQuery = <TData = PickPagePagesQueryResponse, TError = unknown>(
  variables: PickPagePagesQueryVariables,
  options?: UseQueryOptions<PickPagePagesQueryResponse, TError, TData>,
) => {
  return useQuery<PickPagePagesQueryResponse, TError, TData>(
    ['PickPagePages', variables],
    appFetcherGemX<PickPagePagesQueryResponse, PickPagePagesQueryVariables>(
      PickPagePagesDocument,
      variables,
    ),
    options,
  );
};

usePickPagePagesQuery.getKey = (variables: PickPagePagesQueryVariables) => [
  'PickPagePages',
  variables,
];
